"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestConfigBodyToJSON = exports.QuestConfigBodyFromJSONTyped = exports.QuestConfigBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function QuestConfigBodyFromJSON(json) {
    return QuestConfigBodyFromJSONTyped(json, false);
}
exports.QuestConfigBodyFromJSON = QuestConfigBodyFromJSON;
function QuestConfigBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'displayedOn': !(0, runtime_1.exists)(json, 'displayedOn') ? undefined : (json['displayedOn'].map(_1.QuestDisplayFromJSON)),
        'shouldDisplayUnqualified': !(0, runtime_1.exists)(json, 'shouldDisplayUnqualified') ? undefined : json['shouldDisplayUnqualified'],
        'requireProgressionOrder': !(0, runtime_1.exists)(json, 'requireProgressionOrder') ? undefined : json['requireProgressionOrder'],
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': !(0, runtime_1.exists)(json, 'showQuestCompleteNotification') ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': !(0, runtime_1.exists)(json, 'questCompleteNotificationMessage') ? undefined : json['questCompleteNotificationMessage'],
        'questReset': !(0, runtime_1.exists)(json, 'questReset') ? undefined : (0, _1.QuestResetFromJSON)(json['questReset']),
        'milestones': !(0, runtime_1.exists)(json, 'milestones') ? undefined : (json['milestones'].map(_1.QuestConfigMilestoneFromJSON)),
        'prerequisites': !(0, runtime_1.exists)(json, 'prerequisites') ? undefined : (json['prerequisites'].map(_1.PrerequisiteFromJSON)),
        'rewardConfigIds': !(0, runtime_1.exists)(json, 'rewardConfigIds') ? undefined : json['rewardConfigIds'],
        'isSponsored': !(0, runtime_1.exists)(json, 'isSponsored') ? undefined : json['isSponsored'],
        'sponsorName': !(0, runtime_1.exists)(json, 'sponsorName') ? undefined : json['sponsorName'],
        'logo': !(0, runtime_1.exists)(json, 'logo') ? undefined : json['logo'],
        'color': !(0, runtime_1.exists)(json, 'color') ? undefined : json['color'],
        'externalUrl': !(0, runtime_1.exists)(json, 'externalUrl') ? undefined : json['externalUrl'],
        'rewardImage': !(0, runtime_1.exists)(json, 'rewardImage') ? undefined : json['rewardImage'],
        'startAt': !(0, runtime_1.exists)(json, 'startAt') ? undefined : json['startAt'],
        'endAt': !(0, runtime_1.exists)(json, 'endAt') ? undefined : json['endAt'],
    };
}
exports.QuestConfigBodyFromJSONTyped = QuestConfigBodyFromJSONTyped;
function QuestConfigBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'displayedOn': value.displayedOn === undefined ? undefined : (value.displayedOn.map(_1.QuestDisplayToJSON)),
        'shouldDisplayUnqualified': value.shouldDisplayUnqualified,
        'requireProgressionOrder': value.requireProgressionOrder,
        'name': value.name,
        'description': value.description,
        'isActive': value.isActive,
        'showQuestCompleteNotification': value.showQuestCompleteNotification,
        'questCompleteNotificationMessage': value.questCompleteNotificationMessage,
        'questReset': (0, _1.QuestResetToJSON)(value.questReset),
        'milestones': value.milestones === undefined ? undefined : (value.milestones.map(_1.QuestConfigMilestoneToJSON)),
        'prerequisites': value.prerequisites === undefined ? undefined : (value.prerequisites.map(_1.PrerequisiteToJSON)),
        'rewardConfigIds': value.rewardConfigIds,
        'isSponsored': value.isSponsored,
        'sponsorName': value.sponsorName,
        'logo': value.logo,
        'color': value.color,
        'externalUrl': value.externalUrl,
        'rewardImage': value.rewardImage,
        'startAt': value.startAt,
        'endAt': value.endAt,
    };
}
exports.QuestConfigBodyToJSON = QuestConfigBodyToJSON;
